<template>
  <v-text-field
    :placeholder="placeholder"
    outlined
    :label="label"
    v-model="color"
    v-mask="mask"
    hide-details
  >
    <template v-slot:append>
      <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on" style="border: 1px solid black" />
        </template>
        <v-card>
          <v-card-text class="pa-0">
            <v-color-picker mode="hex" @update:color="changeValue" v-model="color" flat />
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  name: "color-field",
  props: ["placeholder", "label", "valueColor"],
  data: () => ({
    mask: "!#XXXXXX",
    color: "#FFFFFF",
    menu: false
  }),
  created() {
    this.color = this.valueColor
  },
  methods: {
     changeValue(newVal) {
      this.$emit("input", newVal.hexa);
    }
  },
  computed: {
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out"
      };
    }
  }
};
</script>